import React from 'react';
import { createPortal } from 'react-dom';

export default function LoadingOverlay({ message = "Espere...", visible }) {
  if (!visible) return null;

  let isDark = false;
  try {
    if (typeof window !== 'undefined') {
      const cached = window.localStorage.getItem('userTheme');
      if (cached) {
        isDark = cached === 'dark';
      } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        isDark = true;
      }
    }
  } catch(e){}

  const defaultBg = isDark ? 'rgba(18, 18, 18, 0.65)' : 'rgba(240, 242, 245, 0.65)';
  const defaultStroke = isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)';
  const defaultText = isDark ? '#e0e0e0' : '#1a1a1a';

  const overlay = (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: `var(--color-overlay, ${defaultBg})`,
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backdropFilter: 'blur(10px) saturate(140%)'
    }}>
      {/* SVG Spinner: Guaranteeing a perfect circle */}
      <div className="svg-spinner-container">
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          xmlns="http://www.w3.org/2000/svg"
          style={{ animation: 'rotate 2s linear infinite' }}
        >
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke={`var(--color-border-light, ${defaultStroke})`}
            strokeWidth="4"
          />
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="var(--color-primary)"
            strokeWidth="4"
            strokeDasharray="80"
            strokeDashoffset="60"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <style>{`
                @keyframes rotate {
                    100% { transform: rotate(360deg); }
                }
                @keyframes dash {
                    0% { stroke-dasharray: 1, 150; stroke-dashoffset: 0; }
                    50% { stroke-dasharray: 90, 150; stroke-dashoffset: -35; }
                    100% { stroke-dasharray: 90, 150; stroke-dashoffset: -124; }
                }
                .svg-spinner-container svg circle:nth-child(2) {
                    animation: dash 1.5s ease-in-out infinite;
                }
            `}</style>

      <h3 style={{
        marginTop: 20,
        color: `var(--color-text, ${defaultText})`,
        fontWeight: 600,
        fontSize: '1.1rem',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        {message}
      </h3>
    </div>
  );

  if (typeof document === 'undefined' || !document.body) {
    return overlay;
  }

  return createPortal(overlay, document.body);
}
